const STORAGE_KEY = "bublyup_cookie_preferences";
export const COOKIE_STORAGE_MAX_AGE = 18 * 30 * 24 * 60 * 60 * 1000;

export function readCookiePreferences() {
  try {
    const value = JSON.parse(localStorage.getItem(STORAGE_KEY) || "null");
    if (!value || value.version !== 1 || !Number.isFinite(Date.parse(value.decidedAt))) return null;
    if (Date.now() - Date.parse(value.decidedAt) >= COOKIE_STORAGE_MAX_AGE) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return value;
  } catch (_error) {
    return null;
  }
}

export function hasSecurityFingerprintConsent() {
  return readCookiePreferences()?.securityFingerprint === true;
}

export function clearDeviceRecognitionStorage() {
  try {
    localStorage.removeItem("bublyup_fingerprint_id");
    localStorage.removeItem("bublyup_fingerprint_created_at");
  } catch (_error) {
    // Storage may be disabled by the browser.
  }
  try {
    if (typeof indexedDB !== "undefined") indexedDB.deleteDatabase("bublyup_db");
  } catch (_error) {
    // Storage may be disabled by the browser.
  }
}
